import { render, staticRenderFns } from "./BusinessDetailsView.vue?vue&type=template&id=51a2a9b5&"
import script from "./BusinessDetailsView.vue?vue&type=script&lang=js&"
export * from "./BusinessDetailsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports